import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

export const SortedGameGhostWord = ({ id }) => {
  return (
    <div className="inline-flex items-center bg-gray-100 rounded-lg px-5 py-3 hover:text-brand cursor-pointer font-extrabold shadow-sm border border-gray-400 uppercase z-[2]">
      {id}
    </div>
  )
}

export const SortedGameWord = ({ id, text }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none',
    whiteSpace: 'normal',
    lineHeight: '1.25rem'
    //   ? '-1px 0 15px 0 rgba(34, 33, 81, 0.01), 0px 15px 15px 0 rgba(34, 33, 81, 0.25)'
    //   : undefined
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="inline-flex items-center bg-gray-100 rounded-lg p-2 md:px-5 md:py-3
      hover:text-brand cursor-pointer font-extrabold shadow-sm
      border border-gray-400 uppercase z-[2] block leading-loose"
    >
      {text}
    </div>
  )
}
